import React, { useState } from 'react';
import {
  Modal,
  Button,
  Card,
  Row,
  Col,
  Typography,
  Divider,
  Radio,
  Tag,
  Form,
  message,
} from 'antd';
import { CheckCircleFilled, FireOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthToken } from '../../../utils/authHelpers';
import _axios from '../../../services/api';
import styles from './subscription.module.scss';
import {
  setStoreCreatedOrderData,
} from '../../../features/Global/globalSlice';
import { API_ROUTES, ORDER_BASE_URL } from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';
import { get_all_Subscriptions_org, get_latest_Subscriptions_org } from '../../../features/Organization/OrganizationInfo/OrganizationSlice';

const { Title } = Typography;

const recruiterPlans = [
  {
    name: 'Starter',
    price: {
      monthly: { INR: '₹50', USD: '$0.60' },
      annually: { INR: '₹500', USD: '$6.02' },
    },
    storage: '1 TB Storage',
    users: '5 Users Allowed',
    bandwidth: 'Send up to 10 GB',
    email: '50 Email Accounts',
    highlight: false,
  },
  {
    name: 'Growth',
    price: {
      monthly: { INR: '₹100', USD: '$1.20' },
      annually: { INR: '₹1,000', USD: '$12.05' },
    },
    storage: '2 TB Storage',
    users: '10 Users Allowed',
    bandwidth: 'Send up to 20 GB',
    email: 'Unlimited Email Accounts',
    highlight: true,
  },
  {
    name: 'Enterprise',
    price: {
      monthly: { INR: '₹200', USD: '$2.41' },
      annually: { INR: '₹2,000', USD: '$24.10' },
    },
    storage: '5 TB Storage',
    users: 'Unlimited Users',
    bandwidth: 'Unlimited Bandwidth',
    email: 'Unlimited Email Accounts',
    highlight: false,
  },
];

const SubscriptionSection = ({ issubscription, setIsSubscription }) => {
  const [billing, setBilling] = useState('monthly');
  const [currency, setCurrency] = useState('INR');
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = getAuthToken();
  const { userProfile } = useSelector((s) => s.global);
  const [form] = Form.useForm();

  const handleSubscribe = async () => {
    if (!selectedPlan) return;
    setLoading(true);
    try {
      const amt = Number(
        selectedPlan.price[billing][currency]
          .replace(/[^0-9.]/g, '')
      );
      const res = await _axios.post(
        `${ORDER_BASE_URL}orders/create`,
        {
          order_amount: amt,
          order_currency: currency,
          customer_details: {
            customer_id: userProfile._id,
            customer_name: userProfile.name,
            customer_email: userProfile.companyEmail,
            customer_phone: userProfile?.contact,
          },
          order_note: `Subscription for ${selectedPlan.name}`,
          order_meta: {
            return_url: `${window.location.origin}/payment-status`,
            payment_methods: 'cc,dc',
          },
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      dispatch(
        setStoreCreatedOrderData(
          res.data.data.payment_session_id
        )
      );
      navigate(`/checkout/${res.data.data.payment_session_id}`);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleApplySubscription = async (values) => {
    setLoading(true);
    try {
      const response = await _axios.post(
        API_ROUTES.ORGANIZATION.SUBSCRIPTION,
        { referalCode: values.referalCode },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );

      message.success(response.data.message);
      setIsSubscription(false);
      dispatch(get_latest_Subscriptions_org(navigate));
      dispatch(get_all_Subscriptions_org(navigate));
      // setSubscription(response.data.subscription);
      form.resetFields();
    } catch (err) {
      console.error(err);
      message.error(err.response?.data?.error || 'Subscription failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      className={styles.orgSubscriptionSection}
      open={issubscription}
      onCancel={() => setIsSubscription(false)}
      footer={null}
      width={950}
      centered
    >
      <Title
        level={3}
        className="text-center text-white large-title"
      >
        Choose Your Subscription Plan
      </Title>

      {/* ── Currency & Billing toggles ── */}
      <Row justify="center" gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col>
          <Radio.Group
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button className={currency === 'INR' ? 'blueGradiant border-none' : 'border-none'} value="INR">INR</Radio.Button>
            <Radio.Button className={currency === 'USD' ? 'blueGradiant border-none' : 'border-none'} value="USD">USD</Radio.Button>
          </Radio.Group>
        </Col>
        <Col>
          <Radio.Group
            value={billing}
            onChange={(e) => setBilling(e.target.value)}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button className={billing === 'monthly' ? 'blueGradiant border-none' : 'border-none'} value="monthly">Monthly</Radio.Button>
            <Radio.Button className={billing === 'annually' ? 'blueGradiant border-none' : 'border-none'} value="annually">Annually</Radio.Button>
          </Radio.Group>
        </Col>
      </Row>

      {/* ── Recruiter Cards ── */}
      <Row gutter={[16, 16]} justify="center">
        {recruiterPlans.map((plan) => (
          <Col xs={24} sm={12} md={8} key={plan.name}>
            <Card
              hoverable
              className={
                selectedPlan?.name === plan.name
                  ? styles.activeplanCard
                  : styles.planCard
              }
              onClick={() => setSelectedPlan(plan)}
              style={{
                border:
                  selectedPlan?.name === plan.name
                    ? '2px solid #198B50'
                    : '1px solid #f0f0f0',
                boxShadow:
                  selectedPlan?.name === plan.name
                    ? '0 0 15px rgba(129, 118, 242, 0.5)'
                    : '0 2px 8px rgba(0, 0, 0, 0.1)',
              }}
            >
              <div className={styles.cardHeader}>
                {plan.highlight && (
                  <Tag
                    icon={<FireOutlined />}
                    color="magenta"
                    className="roundTags"
                  >
                    Most Popular
                  </Tag>
                )}
                <Tag className="roundTags" color="default">
                  {plan.name}
                </Tag>
              </div>

              <Title level={4} className="text-white">
                {plan.price[billing][currency]}
              </Title>

              <ul className={styles.featureList}>
                {[
                  plan.storage,
                  plan.users,
                  plan.bandwidth,
                  plan.email,
                ].map((f, i) => (
                  <li key={i} className="text-white">
                    <CheckCircleFilled
                      style={{
                        color: '#52c41a',
                        marginRight: 8,
                      }}
                    />
                    {f}
                  </li>
                ))}
              </ul>
            </Card>
          </Col>
        ))}
      </Row>

      <Divider />

      <Row justify="end">
        <Col xs={24} sm={12} md={6}>
          <Button
            shape="round"
            onClick={handleSubscribe}
            className="fullwidth btnfonts bg-white text-black"
            type="primary"
            loading={loading}
          >
            Subscribe
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default SubscriptionSection;